export const RidgebackWurfData = {
    Fille1: {
        label: 'Fille1',
        data: [
            0.450, 0.460, 0.530, 0.580, 0.610, 0.650, 0.710,
            0.760, 0.820, 0.900, 0.930, 0.980, 1.030, 1.040,
            1.110, 1.230, 1.340, 1.440, 1.450, 1.570, 1.590,
            1.700, 1.810, 1.920, 2.030, 2.140, 2.250, 2.360,
            2.510, 2.660, 2.810, 2.950, 3.100, 3.250, 3.400,
            3.510, 3.630, 3.740, 3.860, 3.970, 4.090, 4.200,
            4.400, 4.600, 4.800, 5.000, 5.200, 5.400, 5.600
        ],
        borderColor: 'rgba(255, 99, 132, 1)',
        backgroundColor: 'rgba(255, 99, 132, 0.2)',
        sex: 'female'
    },
    Fils2: {
        label: 'Fils2',
        data: [
            0.450, 0.520, 0.520, 0.575, 0.630, 0.690, 0.710,
            0.760, 0.830, 0.910, 0.990, 1.050, 1.060, 1.170,
            1.170, 1.240, 1.310, 1.340, 1.400, 1.510, 1.580,
            1.663, 1.746, 1.829, 1.911, 1.994, 2.077, 2.160,
            2.294, 2.429, 2.563, 2.697, 2.831, 2.966, 3.100,
            3.229, 3.357, 3.486, 3.614, 3.743, 3.871, 4.000,
            4.171, 4.343, 4.514, 4.686, 4.857, 5.029, 5.200
        ],
        borderColor: 'rgba(54, 162, 235, 1)',
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        sex: 'male'
    },
    Fils3: {
        label: 'Fils3',
        data: [
            0.375, 0.410, 0.460, 0.535, 0.570, 0.630, 0.700,
            0.710, 0.770, 0.790, 0.810, 0.850, 0.980, 1.040,
            1.060, 1.200, 1.240, 1.310, 1.380, 1.390, 1.450,
            1.590, 1.730, 1.870, 2.010, 2.150, 2.290, 2.430,
            2.583, 2.736, 2.889, 3.041, 3.194, 3.347, 3.500,
            3.671, 3.843, 4.014, 4.186, 4.357, 4.529, 4.700,
            4.929, 5.157, 5.386, 5.614, 5.843, 6.071, 6.300
        ],
        borderColor: 'rgba(75, 192, 192, 1)',
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        sex: 'male'
    },
    Fils4: {
        label: 'Fils4',
        data: [
            0.530, 0.580, 0.620, 0.690, 0.730, 0.790, 0.840,
            0.910, 1.030, 1.100, 1.130, 1.180, 1.310, 1.300,
            1.410, 1.530, 1.540, 1.640, 1.690, 1.720, 1.810,
            1.926, 2.041, 2.157, 2.273, 2.389, 2.504, 2.620,
            2.789, 2.957, 3.126, 3.294, 3.463, 3.631, 3.800,
            3.971, 4.143, 4.314, 4.486, 4.657, 4.829, 5.000,
            5.229, 5.457, 5.514, 5.914, 6.143, 6.371, 6.600
        ],
        borderColor: 'rgba(255, 206, 86, 1)',
        backgroundColor: 'rgba(255, 206, 86, 0.2)',
        sex: 'male'
    },
    Fils5: {
        label: 'Fils5',
        data: [
            0.420, 0.470, 0.515, 0.615, 0.660, 0.690, 0.750,
            0.780, 0.830, 0.830, 0.920, 0.890, 0.940, 1.030,
            1.050, 1.150, 1.160, 1.180, 1.210, 1.320, 1.380,
            1.481, 1.583, 1.684, 1.786, 1.887, 1.989, 2.090,
            2.249, 2.407, 2.566, 2.724, 2.883, 3.041, 3.200,
            3.357, 3.514, 3.671, 3.829, 3.986, 4.143, 4.300,
            4.529, 4.757, 4.986, 5.214, 5.443, 5.671, 5.900
        ],
        borderColor: 'rgba(153, 102, 255, 1)',
        backgroundColor: 'rgba(153, 102, 255, 0.2)',
        sex: 'male'
    },
    Fils6: {
        label: 'Fils6',
        data: [
            0.535, 0.540, 0.570, 0.610, 0.690, 0.750, 0.810,
            0.930, 1.030, 1.130, 1.200, 1.240, 1.310, 1.400,
            1.490, 1.580, 1.640, 1.730, 1.830, 1.870, 1.910,
            2.030, 2.150, 2.270, 2.390, 2.510, 2.630, 2.750,
            2.914, 3.079, 3.243, 3.407, 3.571, 3.736, 3.900,
            4.086, 4.271, 4.457, 4.643, 4.829, 5.014, 5.200,
            5.414, 5.629, 5.843, 6.057, 6.271, 6.486, 6.700
        ],
        borderColor: 'rgba(255, 159, 64, 1)',
        backgroundColor: 'rgba(255, 159, 64, 0.2)',
        sex: 'male'
    },
    Fils7: {
        label: 'Fils7',
        data: [
            0.450, 0.520, 0.550, 0.650, 0.710, 0.810, 0.870,
            0.920, 1.070, 1.100, 1.220, 1.270, 1.310, 1.390,
            1.390, 1.590, 1.590, 1.650, 1.770, 1.830, 1.920,
            2.014, 2.109, 2.203, 2.297, 2.391, 2.486, 2.580,
            2.769, 2.957, 3.146, 3.334, 3.523, 3.711, 3.900,
            4.100, 4.300, 4.500, 4.700, 4.900, 5.100, 5.300,
            5.514, 5.729, 5.943, 6.157, 6.371, 6.586, 6.800
        ],
        borderColor: 'rgba(0, 128, 128, 1)',
        backgroundColor: 'rgba(0, 128, 128, 0.2)',
        sex: 'male'
    },
    Fils8: {
        label: 'Fils8',
        data: [
            0.470, 0.520, 0.560, 0.620, 0.660, 0.720, 0.740,
            0.810, 0.870, 0.960, 1.040, 1.040, 1.060, 1.150,
            1.190, 1.300, 1.310, 1.350, 1.440, 1.450, 1.570,
            1.684, 1.799, 1.913, 2.027, 2.141, 2.256, 2.370,
            2.531, 2.693, 2.854, 3.016, 3.177, 3.339, 3.500,
            3.686, 3.871, 4.057, 4.243, 4.429, 4.614, 4.800,
            4.986, 5.171, 5.357, 5.543, 5.729, 5.914, 6.100
        ],
        borderColor: 'rgba(0, 255, 0, 1)',
        backgroundColor: 'rgba(0, 255, 0, 0.2)',
        sex: 'male'
    },
    Fille9: {
        label: 'Fille9',
        data: [
            0.405, 0.420, 0.470, 0.530, 0.560, 0.580, 0.620,
            0.720, 0.740, 0.790, 0.850, 0.910, 0.920, 1.000,
            1.090, 1.180, 1.210, 1.300, 1.340, 1.390, 1.480,
            1.560, 1.640, 1.720, 1.800, 1.880, 1.960, 2.040,
            2.220, 2.400, 2.580, 2.760, 2.940, 3.120, 3.300,
            3.457, 3.614, 3.771, 3.929, 4.086, 4.243, 4.400,
            4.614, 4.829, 5.043, 5.257, 5.471, 5.686, 5.900
        ],
        borderColor: 'rgba(128, 0, 128, 1)',
        backgroundColor: 'rgba(128, 0, 128, 0.2)',
        sex: 'female'
    },
    Fille10: {
        label: 'Fille10',
        data: [
            0.395, 0.430, 0.480, 0.530, 0.560, 0.640, 0.690,
            0.750, 0.880, 0.910, 0.940, 1.020, 1.160, 1.170,
            1.170, 1.280, 1.380, 1.400, 1.490, 1.550, 1.590,
            1.709, 1.827, 1.946, 2.064, 2.183, 2.301, 2.420,
            2.574, 2.729, 2.883, 3.037, 3.191, 3.346, 3.500,
            3.643, 3.786, 3.929, 4.071, 4.214, 4.357, 4.500,
            4.714, 4.929, 5.143, 5.357, 5.571, 5.786, 6.000
        ],
        borderColor: 'rgba(0, 0, 0, 1)',
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
        sex: 'female'
    },
    Fille11: {
        label: 'Fille11',
        data: [
            0.520, 0.540, 0.580, 0.620, 0.670, 0.740, 0.810,
            0.880, 0.990, 1.010, 1.070, 1.150, 1.210, 1.220,
            1.320, 1.360, 1.420, 1.490, 1.490, 1.510, 1.550,
            1.671, 1.793, 1.914, 2.036, 2.157, 2.279, 2.400,
            2.543, 2.686, 2.829, 2.971, 3.114, 3.257, 3.400,
            3.571, 3.743, 3.914, 4.086, 4.257, 4.429, 4.600,
            4.814, 5.029, 5.243, 5.457, 5.671, 5.886, 6.100
        ],
        borderColor: 'rgba(255, 165, 0, 1)',
        backgroundColor: 'rgba(255, 165, 0, 0.2)',
        sex: 'female'
    },
    Fille12: {
        label: 'Fille12',
        data: [
            0.510, 0.550, 0.580, 0.640, 0.680, 0.740, 0.780,
            0.870, 0.950, 0.990, 1.120, 1.190, 1.260, 1.320,
            1.330, 1.480, 1.550, 1.580, 1.680, 1.770, 1.910,
            2.019, 2.127, 2.236, 2.344, 2.453, 2.561, 2.670,
            2.803, 2.936, 3.069, 3.201, 3.334, 3.467, 3.600,
            3.743, 3.886, 4.029, 4.171, 4.314, 4.457, 4.600,
            4.814, 5.029, 5.243, 5.457, 5.671, 5.886, 6.100
        ],
        borderColor: 'rgba(75, 0, 130, 1)',
        backgroundColor: 'rgba(75, 0, 130, 0.2)',
        sex: 'female'
    }
};
